import React, { useState } from "react";
import { Alert } from "@mui/material";
import { AddressGroupCard } from "./AddressGroupCard";
import type { AddressGroup, SubscriptionData, ModalType, SubIssues } from "../types";

interface Props {
  addressGroups: AddressGroup[];
  onOpenModal: (type: ModalType, sub: SubscriptionData, addressId?: string) => void;
  onOpenDeliveryModal: (addressId: string) => void;
  onEditAddress?: (addressId: string) => void;
  getVariantInfo: (variantId: string) => any;
  getSubIssues: (subId: string) => SubIssues | undefined;
}

export function SubscriptionsSection({ addressGroups, onOpenModal, onOpenDeliveryModal, onEditAddress, getVariantInfo, getSubIssues }: Props) {
  const [expandedAddresses, setExpandedAddresses] = useState<Set<string>>(new Set());

  const toggleExpansion = (addressId: string) => {
    setExpandedAddresses(prev => {
      const next = new Set(prev);
      if (next.has(addressId)) next.delete(addressId);
      else next.add(addressId);
      return next;
    });
  };

  if (addressGroups.length === 0) {
    return <Alert severity="info">No subscriptions found for this customer</Alert>;
  }

  return (
    <>
      {addressGroups.map(group => (
        <AddressGroupCard
          key={group.addressId}
          group={group}
          expanded={expandedAddresses.has(group.addressId)}
          onToggle={() => toggleExpansion(group.addressId)}
          onOpenDeliveryModal={onOpenDeliveryModal}
          onEditAddress={onEditAddress}
          onOpenModal={onOpenModal}
          getVariantInfo={getVariantInfo}
          getSubIssues={getSubIssues}
        />
      ))}
    </>
  );
}
